jQuery(function ($) {
    $('.sbi-logo-slider .logo-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 9,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none"><path d="M7 12.5L1 6.5L7 0.5M1.83333 6.5H14" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none"><path d="M8 0.5L14 6.5L8 12.5M13.1667 6.5H1" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    })
    $('.sbi-manual-reviews-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 2,
        adaptiveHeight: true,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none"><path d="M7 12.5L1 6.5L7 0.5M1.83333 6.5H14" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none"><path d="M8 0.5L14 6.5L8 12.5M13.1667 6.5H1" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // Hover Top Menu 
    function setupDesktopMenuHover() {
        // Limpia eventos anteriores para evitar duplicación al hacer resize
        $('.nav-item-main-level').off('mouseenter mouseleave');

        if ($(window).width() >= 990) {

        $('.nav-item-main-level').each(function() {
            var $navItem = $(this);
            var $detail = $navItem.find('details').first();

            // Abrir al entrar al LI
            $navItem.on('mouseenter', function() {
            $detail.attr('open', true);
            });

            // Cerrar al salir completamente del LI
            $navItem.on('mouseleave', function() {
            $detail.removeAttr('open');
            });
        });

        } else {
        // En mobile → dejar el comportamiento por defecto (click)
        $('details[open]').removeAttr('open');
        }
    }
    // Ejecutar en load
    setupDesktopMenuHover();

    // Ejecutar en resize (pero con throttling para evitar exceso de ejecución)
    let resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setupDesktopMenuHover, 200);
    });
});
